import { useEffect } from "react";

import { useChatTrailStore } from "@/features/tutor/store/useChatTrailStore";
import { useSlideStore } from "@/features/tutor/store/useSlideStore";

export const useChatTrailLifetime = (
  sessionId: string | number | null | undefined,
): void => {
  const bite = useSlideStore((s) => s.currentSlideIndex);
  const resolved = useSlideStore((s) => s.hasResolvedSlideIndex);
  const enterScope = useChatTrailStore((s) => s.enterScope);

  useEffect(() => {
    if (!resolved || sessionId === null || sessionId === undefined) return;
    enterScope({ session: sessionId, bite });
  }, [resolved, sessionId, bite, enterScope]);
};
